import { InjectionToken, StaticProvider } from '@angular/core';

import { BaseApiConfig } from '../../models/base-api-config.model';

export type ReferralApiConfig = BaseApiConfig<{
  getCode: string;
  getStats: string;
}>;

export const REFERRAL_API_CONFIG = new InjectionToken<ReferralApiConfig>('REFERRAL_API_CONFIG');

export const provideReferralApiConfig = (config: ReferralApiConfig): StaticProvider => ({
  provide: REFERRAL_API_CONFIG,
  useValue: config,
});
